module.exports = __webpack_public_path__ + "img/UpdateActivation.5a6f856b.jpg";